import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-artstamm-list-view',
  imports: [CommonModule],
  templateUrl: './artstamm.list-view.html',
  styleUrls: ['./artstamm.list-view.css'] })
export class ArtstammListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
